enum TableRowScroll {
  horizontal = 8,
  vertical = 30,
}

// 列默认80行，超出开启虚拟
export const TABLE_DEFAULT_HORIZONTAL_ROWS = TableRowScroll.horizontal;
// 行默认8行，超出开启虚拟
export const TABLE_DEFAULT_VERTICAL_ROWS = TableRowScroll.vertical;
// 默认表格样式
export const TABLE_DEFAULT_STYLE = {
  // 表头中一行的高度
  '--header-row-height': '50px',
  // 表头中的字体颜色
  '--header-color': '#262832',
  // 表头上鼠标悬停时的背景色 
  '--header-hover-bgcolor': '#6a96f5',
  // 表头单元格左右边框，
  '--header-cell-border-vertical': '#fff',
  // 表头单元格上下边框
  '--header-cell-border-horizontal': '#fff',
  // 表头的背景色 
  '--header-bgcolor': '#f5f5f8',
  // 表格一行的高度，
  '--row-height': '50px',
  // 表格的字体颜色 
  '--color': '#262832',
  // 鼠标悬停时的背景色
  '--hover-bgcolor': '#f5f5f8',
  // 单元格左右边框，默认为 var(--cell-border)
  '--cell-border-vertical': '#fff',
};
// 分页配置
export const PAGE_SIZE_OPTIONS = [5, 10, 20, 30, 40, 50];
// 分页大小
export const PAGE_SIZE = 10;
// 分页索引
export const PAGE_INDEX = 1;